import useLocalStorage from './useLocalStorage'

const useLocalUserType = () => useLocalStorage('userType')

export default useLocalUserType
